import Colors from "../../theme/colors";

const styles = {
  customTextFieldSecondary: {
    width: "85%",
    marginBottom: 18,
  },
  customTextFieldSecondaryTwo: {
    width: "85%",
    marginBottom: 18,
    paddingLeft: "10px",
  },
  container: {
    display: "flex",
    width: "100%",
    backgroundColor: Colors.midnightBlue,
  },
  tab: {
    width: "25%",
    padding: "10px 12px",
    fontSize: "1rem",
    fontWeight: "700",
    borderBottom: "2px #043D90 solid",
    backgroundColor: Colors.midnightBlue,
    color: Colors.white,
    cursor: "pointer",
  },
  activeTab: {
    backgroundColor: Colors.white,
    color: Colors.black,
  },
  main: {
    minHeight: 0,
  },
  gridPrimary: {
    marginBottom: 25,
  },
};

export default styles;
